import styled from "@emotion/styled";

export const StyledImage = styled.img`
  inline-size: 21px;
  block-size: 18px;
`;
